export default {
  correspondencias: [],
  eventos: [],
}
